import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page53"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "7%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];

// 引入图片
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图 from '@/assets/v2/page5-3/图.webp';
import wenzi1 from '@/assets/v2/page5-3/文字/wenzi1.webp';
import 阳台面宽 from '@/assets/v2/page5-3/文字/阳台面宽.webp';
import 大尺寸地砖 from '@/assets/v2/page5-3/文字/大尺寸地砖.webp';
import 预留洗手池 from '@/assets/v2/page5-3/文字/预留洗手池.webp';
import 竖线1 from '@/assets/v2/page5-1/标识线/竖线1.webp';
import 椭圆黑 from '@/assets/v2/page5-1/标识线/椭圆黑.webp';
import 预留洗衣机 from '@/assets/v2/page5-3/文字/预留洗衣机.webp';
export default {
  __name: 'Page5-3',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线1",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑1",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(阳台面宽),
        alt: "阳台面宽",
        class: "阳台面宽",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线2",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑2",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(预留洗衣机),
        alt: "预留洗衣机",
        class: "预留洗衣机",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(图),
        alt: "图",
        class: "图",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(大尺寸地砖),
        alt: "大尺寸地砖",
        class: "大尺寸地砖",
        loading: "lazy"
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑5",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线5",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(预留洗手池),
        alt: "预留洗手池",
        class: "预留洗手池",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑6",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线6",
        loading: "lazy"
      }, null, 8, _hoisted_18)])]);
    };
  }
};